import { Card, CardBody } from '@heroui/react';

interface AnswerBoxProps {
  id: string;
  title: string;
  answer: string;
  steps?: string[];
}

/** Short "what X does" answer near the top of a commercial page. */
export function AnswerBox({ id, title, answer, steps }: AnswerBoxProps) {
  return (
    <section className="relative px-6 pb-12" aria-labelledby={id}>
      <div className="mx-auto max-w-4xl">
        <Card className="border border-foreground-200 bg-content1/60 backdrop-blur-lg">
          <CardBody className="flex flex-col gap-4 p-6 sm:p-8">
            <h2 id={id} className="font-sans text-xl font-bold sm:text-2xl">
              {title}
            </h2>
            <p className="text-base leading-relaxed text-foreground-600">{answer}</p>
            {steps && steps.length > 0 ? (
              <ol className="grid list-decimal gap-2 pl-5 text-base text-foreground-600 sm:grid-cols-2">
                {steps.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            ) : null}
          </CardBody>
        </Card>
      </div>
    </section>
  );
}
